// extracted by mini-css-extract-plugin
export default {"fieldContainer":"PromotionBarSlideEditModal_fieldContainer__y38nG","field":"PromotionBarSlideEditModal_field__NK05A","flag":"PromotionBarSlideEditModal_flag__Tisbz"};